import { render } from "./Contactus.vue?vue&type=template&id=18d47b71"
import script from "./Contactus.vue?vue&type=script&lang=ts"
export * from "./Contactus.vue?vue&type=script&lang=ts"

import "./Contactus.vue?vue&type=style&index=0&id=18d47b71&lang=css"
script.render = render

export default script